<div class="secure-alert d-flex flex-row align-items-center">
  <ds-icon [icon]="alertIcon"></ds-icon>
  <div class="alert-content" [innerHTML]="alert | translateHtml"></div>
</div>
